import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Tooltip,
  useClipboard,
  Text
} from '@chakra-ui/react';
import { CopyIcon, CheckIcon } from '@chakra-ui/icons';

interface CompactUrlDisplayProps {
  url: string | null;
  maxWidth?: string;
}

export const CompactUrlDisplay: React.FC<CompactUrlDisplayProps> = ({ 
  url, 
  maxWidth = '300px' 
}) => {
  const { hasCopied, onCopy } = useClipboard(url || '');
  const [showTooltip, setShowTooltip] = useState(false);

  if (!url) {
    return <Text fontSize="xs" color="gray.500">No URL</Text>;
  }

  // Truncate URL for display
  const displayUrl = url.length > 50 ? `${url.substring(0, 47)}...` : url;

  return (
    <Flex align="center" maxW={maxWidth}>
      <Tooltip 
        label={url} 
        isOpen={showTooltip} 
        placement="top"
        hasArrow
      >
        <InputGroup size="xs">
          <Input 
            value={displayUrl} 
            isReadOnly 
            pr="2.5rem"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={() => setShowTooltip(true)}
            fontSize="xs"
          />
          <InputRightElement width="2.5rem">
            <Button 
              h="1.4rem" 
              size="xs" 
              onClick={onCopy}
              aria-label="Copy URL"
            >
              {hasCopied ? <CheckIcon /> : <CopyIcon />}
            </Button>
          </InputRightElement>
        </InputGroup>
      </Tooltip>
    </Flex>
  );
};
